import api from "../../api"
import { normalize } from "normalizr"
import { sendNotification } from "../../application.actions"

export const IRR_SAMPLE_RETRIEVED = "IRR_SAMPLE_RETRIEVED"
export const IRR_SAMPLE_CLEARED = "IRR_SAMPLE_CLEARED"
export const IRR_SAMPLE_GRID_FILTER_CHANGED = "IRR_SAMPLE_GRID_FILTER_CHANGED"
export const IRR_SAMPLE_GRID_SORT_CHANGED = "IRR_SAMPLE_GRID_SORT_CHANGED"
export const IRR_SAMPLE_GRID_PAGINATION_CHANGED = "IRR_SAMPLE_GRID_PAGINATION_CHANGED"
export const IRR_SAMPLE_REVIEWER_REASSIGNED = "IRR_SAMPLE_REVIEWER_REASSIGNED"
export const IRR_SAMPLE_REVIEW_RETRIEVED = "IRR_SAMPLE_REVIEW_RETRIEVED"
export const IRR_SAMPLE_REVIEW_SAVED = "IRR_SAMPLE_REVIEW_SAVED"

export const fetchIrrSample = (sampleId) => async (dispatch, getState) => {
  return await api(dispatch).get(`irrs/${sampleId}`, (response) => ({
    type: IRR_SAMPLE_RETRIEVED,
    payload: response,
  }))
}

export const fetchIrrReview = (sampleId, recordId) => async (dispatch, getState) => {
  return await api(dispatch).get(`irrs/${sampleId}/reviews/${recordId}`, (response) => ({
    type: IRR_SAMPLE_REVIEW_RETRIEVED,
    payload: response,
  }))
}

export const saveIrrReview = (periodId, sampleId, recordId, formData) => async (dispatch, getState) => {
  const body = mapFormValue(formData);

  return await api(dispatch).post(`irrs/${periodId}/${sampleId}/reviews/${recordId}`, body, response => [
    {type: IRR_SAMPLE_REVIEW_SAVED, payload: response},
    sendNotification(`IRR review saved.`)
  ]);
};

const mapFormValue = (formData) => {
  const x = Object.keys(formData).reduce((a, c) => ({...a, [c]: formData[c].value}), formData);
  console.log("mapFormValue", x)
  return x;
};

export const reassignReviewer = (periodId, sampleId, reviewer) => async (dispatch, getState) => {
    const body = {
        reviewer
    };
    return await api(dispatch).post(`irrs/${periodId}/${sampleId}/reassign-reviewer`, body, response => [
        {type: IRR_SAMPLE_REVIEWER_REASSIGNED, payload: response},
        sendNotification('Reviewer reassigned.')
    ]);
}

export const gridFilterChanged = (gridFilterModel) => ({
  type: IRR_SAMPLE_GRID_FILTER_CHANGED,
  payload: gridFilterModel,
})

export const gridSortChanged = (gridSortModel) => ({
  type: IRR_SAMPLE_GRID_SORT_CHANGED,
  payload: gridSortModel.map((x) => ({ ...x })),
})

export const gridPaginationChanged = (currentPage) => ({
  type: IRR_SAMPLE_GRID_PAGINATION_CHANGED,
  payload: {
    currentPage: currentPage,
  },
})

export const clearIrrSample = () => ({ type: IRR_SAMPLE_CLEARED })



// WEBPACK FOOTER //
// ./src/modules/irr-sample/irr-sample.actions.js